import { PermissionAction, PermissionResource } from '@entities/tenant/permission';

import {
  Ticket01Icon,
  Users02Icon,
  User01Icon,
  UserPlusIcon,
  CreditCard01Icon,
  ReceiptIcon,
  Percent03Icon,
  ClipboardIcon,
  FileAttachment02Icon,
} from '@shared/ui/icons';

import type { TenantNavItem } from '../model';

import { sx } from './navigation-icon-sx';

export const adminNavigationItems: TenantNavItem[] = [
  {
    label: 'Системні ліміти',
    path: '/admin/limit-templates',
    resource: PermissionResource.TenantLimits,
    icon: <CreditCard01Icon sx={sx} />,
  },
  {
    label: 'Прейскуранти',
    path: '/admin/prices/products',
    resource: PermissionResource.TenantPrices,
    icon: <ReceiptIcon sx={sx} />,
  },
  {
    label: 'Дебітори',
    // path: '/debtors',
    icon: <Users02Icon sx={sx} />,
    children: [
      {
        label: 'Клієнти',
        path: '/debtors/clients',
        resource: PermissionResource.TenantClients,
      },
      {
        label: 'Агенти',
        path: '/debtors/agents',
        resource: PermissionResource.TenantClients,
      },
      {
        label: 'Овердрафти',
        path: '/debtors/overdrafts',
        resource: PermissionResource.TenantOverdrafts,
      },
    ],
  },
  {
    label: 'Договори',
    path: '/admin/contracts',
    resource: PermissionResource.TenantContracts,
    icon: <FileAttachment02Icon sx={sx} />,
  },
  {
    label: 'Знижки',
    resource: PermissionResource.TenantDiscounts,
    icon: <Percent03Icon sx={sx} />,
    children: [
      {
        label: 'Клієнтські знижки',
        path: '/admin/discounts/clients',
      },
      {
        label: 'Список знижок',
        path: '/admin/discounts/list',
      },
      {
        label: 'Групи знижок',
        path: '/admin/discounts/groups',
      },
      {
        label: 'Ретро бонус',
        path: '/admin/discounts/retro-bonus',
      },
      {
        label: 'Заявки на погодження',
        path: '/admin/discounts/approval-requests/incoming',
        resource: PermissionResource.TenantDiscountApprovals,
        action: PermissionAction.Decide,
      },
      {
        label: 'Мої заявки на погодження',
        path: '/admin/discounts/approval-requests/mine',
        resource: PermissionResource.TenantDiscountApprovals,
      },
      {
        label: 'Рольові ліміти знижок',
        path: '/admin/discounts/role-limits',
      },
    ],
  },
  {
    label: 'Талони',
    icon: <Ticket01Icon sx={sx} />,
    children: [
      {
        label: 'Список талонів',
        path: '/admin/coupons/list',
        resource: PermissionResource.TenantCoupons,
      },
      {
        label: 'Заяви на повернення',
        path: '/admin/coupons/refund',
        resource: PermissionResource.TenantCouponRefundRequests,
      },
    ],
  },
  {
    label: 'Замовлення',
    // тимчасово беремо пермішен знижок, поки бекенд не завів окремий тенант-ресурс
    resource: PermissionResource.TenantDiscounts,
    icon: <ClipboardIcon sx={sx} />,
    children: [
      {
        label: 'Талони',
        path: '/admin/coupon-orders',
      },
      {
        label: 'Партії пального',
        path: '/admin/fuel-orders',
      },
    ],
  },
  {
    label: 'Користувачі',
    resource: PermissionResource.TenantUsers,
    icon: <User01Icon sx={sx} />,
    children: [
      {
        label: 'Користувачі',
        path: '/admin/users/list',
      },
      {
        label: 'Ролі',
        path: '/admin/users/roles',
      },
    ],
  },
  {
    label: 'Водії',
    path: '/admin/drivers',
    resource: PermissionResource.TenantDrivers,
    icon: <UserPlusIcon sx={sx} />,
  },
  {
    label: 'Картки',
    resource: PermissionResource.TenantCards,
    icon: <CreditCard01Icon sx={sx} />,
    children: [
      {
        label: 'Видані',
        path: '/admin/cards/issued',
      },
      {
        label: 'Не видані',
        path: '/admin/cards/unissued',
      },
    ],
  },
];
